// extracted by mini-css-extract-plugin
export default {"cardscontainer":"Website_cardscontainer__wb566","cards":"Website_cards__bHIgr"};